export default {
  en: {
    pageTitle: 'Zeus',
    tabs: {
      orgs: 'Organisations',
      users: 'Users',
      threats: 'Emerging Threats',
      federated: 'Federated',
      trials: 'Trials',
      inviteReminders: 'Invite reminders',
      featureFlags: 'Feature flags',
    },
    featureFlags: {
      add: 'Add feature flag',
      addFlagNamePlaceholder: 'Enter a name...',
      addFlagNameLabel: 'Name',
      addFlagDefaultEnabledLabel: 'Default enabled',
      addButton: 'Create flag',
      camelCase: 'Name must be camelCase',
      delete: 'Delete',
      save: 'Save',
      deleteFlagConfirmation:
        'Are you sure you want to delete the {flagName} flag GLOBALLY FOREVER?',
      deleteFlagButton: 'Delete flag',
      overrides: 'Overrides',
      overridesTitle: 'Overrides for {flagName}',
      close: 'Close',
      addOverride: 'Add override',
      addOverrideOrgIdLabel: 'Org ID',
      addOverrideOrgIdPlaceholder: 'Enter a valid org ID...',
      addOverrideUserIdLabel: 'User ID',
      addOverrideUserIdPlaceholder: 'Enter a valid user ID...',
      addOverrideButton: 'Create override',
      deleteOverride: 'Delete override',
      deleteOverrideConfirmation: 'Are you sure you want to delete override for {overrideName}?',
      deleteOverrideButton: 'Delete override',
      disable: 'Disable',
      enable: 'Enable',
      enableOverride: 'Enable override',
      disableOverride: 'Disable override',
      confirmToggle: 'Toggle {flagName}',
      confirmToggleDescription: 'Are you sure you want to {toggle} the {flagName} flag GLOBALLY?',
      confirmToggleOverrideDescription:
        'Are you sure you want to {toggle} the {flagName} flag for this override?',
      org: 'Org',
      user: 'User',
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    orgList: {
      noSelection: 'No organisation selected',
      filterBy: 'Filter by:',
      sortBy: 'Sort by:',
      supplier: 'Supplier',
      client: 'Client',
      federated: 'Federated',
      deleted: 'Deleted',
      notDeleted: 'Not deleted',
      unclaimed: 'Unclaimed',
      name: 'Name',
      dateJoined: 'Creation date',
    },
    userList: {
      search: 'Search users',
      noSelection: 'No user selected',
    },
    searchPlaceholder: 'Search',
    orgPage: {
      fetchingFailed: 'Failed to get organisation info. Please contact engineering team.',
      managed: 'Managed',
      client: 'Client',
      unclaimed: 'Unclaimed',
      claimed: 'Claimed',
      supplier: 'Supplier',
      federated: 'Federated',
      subEntities: 'Federated sub entities',
      joined: 'Joined {date}',
      status: 'Status',
      profiles: 'Profiles',
      website: 'Website',
      update: 'Update',
      access: {
        basic: 'Basic access',
        full: 'Full access',
      },
      unconfirmed: 'Unverified connection',
      fourthParty: 'Added as supplier-side critical supplier',
      statusTooltip: {
        unconfirmed: 'Lead user has not confirmed their email/phone yet.',
        active:
          'Lead has confirmed email/phone. Org users have access to RL, depending on whether the org is suspended or not.',
        unclaimedSupplier: 'Supplier has not claimed their profile yet.',
        deleted: 'Org is permanently deleted. No other orgs can interact with this org anymore.',
      },
      unconfirmedWithActiveUsers: 'This organisation has confirmed users but is unconfirmed',
      confirmOrg: {
        button: 'Confirm organisation',
        title: 'Confirm {0}?',
        description: 'Confirming an org will allow its users to login and use Risk Ledger.',
        checkbox:
          'I understand that this is NOT REVERSIBLE and have double-checked with others that this is the correct organisation to confirm.',
        confirm: 'Confirm organisation',
        failed: 'Failed to confirm org.',
      },
      demoteOrg: {
        title: 'Demote {0} to an unclaimed profile?',
        description:
          'Demoting this organisation to unclaimed will permanently delete SOME data from Risk Ledger.',
        checkbox:
          'I understand that this is NOT REVERSIBLE and have double-checked with others that this is the correct organisation to demote to unclaimed.',
        confirm: 'Demote to unclaimed',
        failed: 'Failed to demote org.',
        button: 'Demote to unclaimed',
      },
      deleteUnclaimedOrg: {
        title: 'Delete {0} unclaimed profile from Risk Ledger?',
        button: 'Delete unclaimed profile',
        description: 'Deleting this unclaimed profile will fully remove it from the network.',
        checkbox:
          'I understand that this is NOT REVERSIBLE and have double-checked with others that this is the correct organisation to delete.',
        confirm: 'Delete PERMANENTLY',
        failed: 'Failed to delete org.',
      },
      deleteFederatedOrg: {
        title: 'Delete {0} federated profile from Risk Ledger?',
        button: 'Delete federated profile',
        description: 'Deleting this federated profile will fully remove it from the network.',
        checkbox:
          'I understand that this is NOT REVERSIBLE and have double-checked with others that this is the correct organisation to delete.',
        confirm: 'Delete PERMANENTLY',
        failed: 'Failed to delete org.',
      },
      isSuspended: {
        status: 'Suspended',
        tooltip: 'Org users are blocked from logging in and using RL.',
        button: 'Unsuspend',
        title: 'Unsuspend {0}?',
        description: 'Unsuspending an org will allow its users to login and use Risk Ledger again.',
        failed: 'Failed unsuspending org.',
      },
      isNotSuspended: {
        status: 'Not suspended',
        tooltip: 'Org users can login and access RL.',
        button: 'Suspend',
        title: 'Suspend {0}?',
        description:
          'Suspending an org will block its users from logging in and using Risk Ledger. This block will be in effect until the org is unsuspended.',
        failed: 'Failed suspending org.',
      },
      isHidden: {
        status: 'Hidden',
        tooltip:
          'This org will not be shown to other orgs in search results, quick-connect page, or invite suggestions.',
        button: 'Unhide',
        title: 'Unhide {0}?',
        description:
          'Unhiding an org will allow other orgs to see them in search results, quick-connect page, and invite suggestions.',
        failed: 'Failed unhiding org.',
      },
      isNotHidden: {
        status: 'Not hidden',
        tooltip:
          'This org is shown to other org in search results, quick-connect page, and invite suggestions.',
        button: 'Hide',
        title: 'Hide {0}?',
        description:
          'Hiding an org will stop other orgs from seeing them in search results, quick-connect page, and invite suggestions.',
        failed: 'Failed hiding org.',
      },
      isPaid: {
        status: 'Paid',
        tooltip: 'This org is marked as a paying client.',
        button: 'Unmark as paid',
        title: 'Unmark {0} as paid?',
        description: 'Unmarking a client org as paid indicates it is a non-paying client.',
        failed: 'Failed unmarking org as paid.',
      },
      isNotPaid: {
        status: 'Not paid',
        tooltip: 'This org is marked as a non paying client',
        button: 'Mark as paid',
        title: 'Mark {0} as paid?',
        description: 'Marking an org as paid indicates it is a paying client.',
        failed: 'Failed marking org as paid.',
      },
      isClientRestricted: {
        status: 'Client side restricted',
        tooltip: 'This org is marked as restricted from viewing the client side',
        button: 'Mark as unrestricted',
        title: 'Mark {orgName} as unrestricted?',
        description: 'Marking an org as unrestricted indicates that they can view the client side.',
        failed: 'Failed marking org as unrestricted.',
      },
      isNotClientRestricted: {
        status: 'Client side not restricted',
        tooltip: 'This org is marked as unrestricted from viewing the client side',
        button: 'Mark as restricted',
        title: 'Unmark {orgName} as restricted?',
        description:
          'Marking an org as restricted indicates that they can no longer view the client side.',
        failed: 'Failed marking org as restricted.',
      },
      users: 'Users',
      userTooltip: 'Created {0} ({1})',
      user: '{firstName} {lastName} ({role}, {team})',
      userNoTeam: 'no team',
      addUser: 'Add user',
      clients: 'Clients',
      suppliers: 'Suppliers',
      connectionTooltip: 'Connected {0} ({1})',
      assessment: 'Assessment',
      assessmentStatus: 'Assessment status:',
      reassessmentStatus: 'Reassessment status:',
      assessmentProgress: 'Assessment progress:',
      reassessmentProgress: 'Reassessment progress:',
      nextReassessment: 'Next reassessment due at:',
      notSubmitted: 'Not submitted',
      percentage: '{0}% complete',
      assessmentComplete: 'Initial assessment complete',
      scopingComplete: 'Scoping questions complete',
      scopingIncomplete: 'Waiting for scoping questions',
      idle: 'Complete',
      reassessment_due: 'Due',
      reassessment_overdue: 'Overdue',
      reassessment_inprogress: 'In progress',
      initial_inprogress: 'Initial assessment in progress',
      csvRequiredExport: 'Export required answers as CSV',
      csvAllAnswersExport: 'Export all answers as CSV',
      exportError: 'Error exporting assessment',
      assessmentRemindersPause: 'Pause initial assessment and reassessment reminders',
      assessmentRemindersError: 'There was an error toggling the pause.',
      sso: 'SSO',
      ssoStatus: 'SSO status:',
      ssoSamlStatus: 'SSO SAML status:',
      ssoOauthStatus: 'SSO Google OAuth status:',
      ssoTooltip:
        'Single sign-on (SSO) allows users to log in using their own identity provider instead of their RL password.',
      ssoSamlTooltip:
        'Wether the org has setup their SAML SSO configuration & are using SAML as their SSO method.',
      ssoOauthTooltip:
        'Wether the org has enabled their Google OAuth SSO configuration & are using Google OAuth as their SSO method.',
      ssoEnforced: 'SSO enforced:',
      ssoEnforcedTooltip:
        'Enforcing SSO means users can only login this way and are not allowed to use their RL password (unless their role is Admin or higher).',
      jit: 'JIT user provisioning:',
      jitTooltip:
        "When just-in-time (JIT) user auto-provisioning is enabled, users form the org's identity provider will be able to login to RL and have an account automatically made for them if they don't have one yet.",
      jitRole: 'JIT default user role:',
      jitRoleTooltip:
        'The initial role that the auto-provisioned user will have. Their role can still be changed later.',
      enabled: 'Enabled',
      disabled: 'Disabled',
      moreInfo: 'More information',
      pendingCRs: 'Pending connection requests',
      pendingInvites: 'Pending invites',
      inTrial: 'In active trial',
      notInTrial: 'Not in trial',
      seeTrial: 'See trial',
      tos: {
        headline: 'Terms of Service',
        agreement: 'agreed to our',
        deletedUser: ' (user was deleted on {date})',
        date: 'on the',
      },
      sortBy: 'Sort by: ',
      sortOptions: {
        name: 'Name',
        createdAt: 'Created date',
        connectedAt: 'Connected date',
        role: 'Role',
        team: 'Team',
        access: 'Connection access',
        ownershipStatus: 'Organisation ownership status',
      },
      externalMonitoringAssets: {
        title: 'External monitoring',
        noMonitoringData: 'No monitoring data available',
        value: 'Asset',
        description: 'Description',
        modifiedBy: 'Last modified by',
        modifiedAt: 'Last modified at',
        source: 'Source',
        status: 'Status',
        toggleStatus: 'Toggle asset status',
      },
      expiredInvites: {
        title: 'Expired invites',
        noExpiredInvites: 'No expired invites',
        fetchingFailed: 'Failed to load expired invites',
        filterPlaceholder: 'Filter by organisation',
        resend: 'Resend',
        resendSuccess: 'Invite resent successfully',
        resendError: 'Failed to resend invite. Please try again.',
        expiredAt: 'Expired at',
        expiredAgo: 'Expired {0}',
        columns: {
          organisation: 'Organisation',
          email: 'Email',
          status: 'Status',
          expiredAt: 'Expired at',
          sentBy: 'Sent by',
          actions: 'Actions',
        },
      },
    },
    export: {
      letter: 'Letter',
      number: 'Number',
      question: 'Question',
      answer: 'Answer',
      notes: 'Notes',
      product: 'Product',
      evidence: 'Evidence',
      inRelationToProduct: 'In relation to {product}, {question}',
    },
    userPage: {
      userID: 'User ID',
      cognitoID: 'Cognito ID',
      cognitoStatus: 'Cognito status',
      authenticatorEnabled: 'Authenticator enabled',
      true: 'True',
      false: 'False',
      orgID: 'Org ID',
      name: 'Name',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      role: 'Role',
      team: 'Team',
      mode: 'Mode permission',
      status: 'Status',
      ssoSamlEnabled: 'SSO SAML enabled',
      ssoOauthEnabled: 'SSO Google OAuth enabled',
      ssoOnly: 'SSO only',
      unconfirmed: 'Unconfirmed',
      active: 'Active',
      setMFAToSMS: 'Set MFA to SMS',
      resetMFA: 'Reset MFA preference',
      confirmUser: 'Confirm user',
      confirmUserAndOrg: 'Confirm user and organisation',
      generateNewPassword: 'Generate new temporary password',
      resendTempPassword: 'Send new temporary password email',
      edit: 'Edit user',
      cancel: 'Cancel',
      add: 'Add user',
      generalWarning: 'Be sure you are editing the correct user!',
      resendTempPassWarning:
        'This will send a new email to the user containing a new temporary password.',
      setMFAToSMSWarning:
        "The user's authenticator will stop being valid and 2FA will change to SMS on the user's registered phone number.",
      resetMFAWarning:
        "The user's MFA preference will be reset and they will be forced to set it up again on login.",
      mfaPreference: 'MFA/2FA preference',
      mfaNotSet: 'Not set',
      leadChangeWarning:
        "Setting a new Lead will demote the organisation's current Lead to an Admin.",
      confirmUserWarning:
        'We should make every effort to get the users to confirm themselves through normal email confirmation.',
      confirmUserWarning2: 'This will also mark the organisation as active.',
      sureCheckbox:
        "I'm sure the user i'm helping is not being impersonated and i've confirmed their identity.",
      sureTooltip: 'Please make sure to confirm the identity of the user first',
      newPasswordWarning:
        'This will generate a new temporary password for the user and replace the existing one.',
      newPasswordWarning2:
        "It won't send an email, it will be displayed here for you to copy and share with the user.",
      newPasswordWarning3: 'The user will be required to change their password on next login.',
      resendTempPassDone: 'Success! the user should receive a new email.',
      editDone: 'Success! user details updated.',
      confirmUserDone: 'Success! the org and user are now confirmed.',
      setMFAToSMSDone: "Success! the user's MFA has been changed to SMS",
      resetMFADone: "Success! the user's MFA preference has been reset",
      newPasswordPlaceholder: 'The new password will appear here',
      newPasswordDone: 'Success! copy the password and share it with the user.',
      close: 'Close',
      alreadyExists: 'A user with that email already exists.',
      error: 'An error occurred. Please try again.',
      refresh: 'Refresh',
      sendInvites: 'Send invites as {0}',
      createConnectionRequests: 'Create connection requests as {0}',
      labels: {
        lead: 'Lead',
        admin: 'Admin',
        edit: 'Edit',
        view: 'View',
        client: 'Client',
        supplier: 'Supplier',
        client_supplier: 'Client & supplier',
        federated: 'Federated',
      },
      noTeam: 'No team',
      teamPlaceholder: 'Select team for user',
      delete: 'Delete',
      deleteUser: 'Delete user',
      deleteSpecificUser: 'Delete user: {0}',
      deleteWarning: 'Be sure you are deleting the correct user!',
      deleteEffects: 'The user will no longer be able to access RL with their account.',
      userIsLead:
        "This is a Lead user; they cannot be deleted. Promote another user to be the organisation's Lead before deleting this one.",
      userIsSelf: 'This user is you! Please get someone else to delete you.',
      deleteCheckbox:
        "I'm sure the user i'm helping is not being impersonated, i've confirmed their identity, and this is the correct user to delete.",
      whyDelete: 'Why is this user being deleted?',
      deleteConfirmTooltip:
        "Please confirm you're deleting the correct user and provide a reason for deleting them.",
      deleteSucceeded: 'User deleted.',
      deleteFailed: 'Failed to delete user.',
      restrictSupplierAccess: 'Restrict supplier access',
    },
    bulkInvites: {
      changeSender: 'Change sender',
      pageTitle: 'Send invites as {user} from {org}',
      pageDescription:
        'This page enables you to send invites from the sender above to recipients defined in a CSV file or manually adding them. If you have an excel file then save it as a CSV.',
      pageDescriptionForCreate:
        'This page enables you to create suppliers and send invites from the sender above to recipients defined in a CSV file or manually adding them. If you have an excel file then save it as a CSV.',
      csvDescription:
        'The CSV file should have no header and each row should be an organisation name and email separated by a comma. An org name with commas must be enclosed in double quotes. For example:',
      csvDescriptionForCreate:
        'The CSV file should have no header and each row should be an organisation name, email, location, sector and website separated by a comma. An org name with commas must be enclosed in double quotes. For example:',
      csvExample:
        "Apple Inc,steve{'@'}apple.com\n\"This, org, name has commas\",alice{'@'}supplier.com",
      csvExampleForCreate:
        "Apple Inc,steve{'@'}apple.com,USA,Agriculture,http://apple.com\n\"This, org, name has commas\",alice{'@'}supplier.com,USA,Agriculture,http://alice.com",
      load: 'Load CSV',
      loadFailed: 'Failed to load CSV. Ensure it follows the format above and try again.',
      invites: 'Invites',
      orgName: 'Organisation name',
      email: 'Email',
      location: 'Location',
      sector: 'Sector',
      website: 'Website',
      sentTooltip: 'Sent!',
      send: 'Send',
      inviteExists: 'Invite already exists!',
      orgExists: 'Organisation already exists!',
      connectionExists: 'Organisation is already connected to the existing contact!',
      unexpectedError: 'Unexpected error: {0}',
      allSent: 'Sent all invites!',
      allCreated: 'Created all suppliers and sent all invites!',
      invalidInvites: 'One or more invites have an invalid name and/or email.',
      invalidOrgs: 'One or more organisations have an invalid inputs',
      sendingError: 'Failed to send invites; try again or contact the dev team.',
      creatingError:
        'Failed to create suppliers and send invites; try again or contact the dev team.',
      someFailed: 'Some invites have failed to send; review the inputs and try again.',
      primerEmail: {
        desc: 'I confirm a {primerEmail} has been sent to each supplier.',
        link: 'Primer email',
      },
    },
    bulkCreateConnectionRequests: {
      pageTitle: 'Create connection requests as {user} from {org}',
      pageDescription:
        'This page enables you to create connection requests from the sender above to recipients defined in a CSV file or by manually adding them. If you have an excel file then save it as a CSV.',
      supplierID: 'Supplier ID',
      invalidSupplierID: 'Invalid supplier ID',
      supplierName: 'Supplier name',
      supplierError: 'Failed fetching supplier.',
      contactEmail: 'Contact email',
      contactName: 'Contact name',
      messageOverride: 'Connection request message override',
      message: 'Connection request message',
      newRequests: 'New connection requests',
      add: 'Add',
      remove: 'Remove',
      send: 'Send',
      pageDescriptionForCreate:
        'This page enables you to create connection requests in bulk for a given client for a list of suppliers. You can upload a CSV file or manually add new rows.',
      csvDescriptionForCreate:
        'The CSV file should have no header and each row should be a supplier ID, contact email, contact name and optional message override separated by a comma.',
      csvExampleForCreate:
        "648db235-473a-4bb8-a604-0f18dfb05ccb,jane{'@'}supplier.com,Jane Doe,This is an override message\n7095852f-9840-4302-b028-ae0d16d19480,joe{'@'}supplier.com,Joe Bloggs,",
      someFailed: 'Some connection requests have failed to send; review the errors above.',
      allCreated: 'All connection requests have been created!',
      allowEmptyContactDetailsCheckbox:
        'Yes, I am sure I want to allow empty contact details for some or all connection requests, even though it is not recommended.',
    },
    inviteRemindersPage: {
      active: 'Active',
      paused: 'Paused',
      toggleSuccess: 'Successfully updated invite reminder pause status',
      toggleError: 'Failed updating invite reminder pause status',
      searchPlaceholder: 'Search',
      sortSentAtTooltip: 'Sort by sent date',
    },
    federated: {
      orgDataTable: {
        filterAttributes: {
          name: 'Name',
        },
        columns: {
          name: 'Organisation name',
          createdBy: 'Created by',
          action: 'Actions',
        },
        error: {
          title: 'Federated organisations',
          description: 'Failed fetching organisations.',
        },
        emptyList: {
          title: 'Federated organisations',
          description: 'No federated organisations can be found.',
        },
        actionButton: {
          label: 'Manage',
        },
        deletedUser: 'Deleted user',
      },
      createPanel: {
        title: 'Federated setup',
        subtitle: 'Create organisation',
        description:
          "To setup a federated organisation, enter their organisation details below. Once created you'll be then prompted to add their first user.",
        nameInput: {
          label: 'Name',
          placeholder: 'Enter a name',
          error: {
            required: 'Please enter a name.',
          },
        },
        websiteInput: {
          label: 'Website',
          placeholder: 'Enter a website',
          error: {
            required: 'Please enter a website.',
            url: 'Please enter a valid website.',
          },
        },
        countryInput: {
          label: 'Country',
          placeholder: 'Select a country',
          error: {
            required: 'Please select a country.',
          },
        },
        industryInput: {
          label: 'Industry',
          placeholder: 'Select an industry',
          error: {
            required: 'Please select an industry.',
          },
        },
        showPanelButton: {
          label: 'Create organisation',
        },
        createError: 'Failed creating federated organisation. Please try again.',
        closeButton: {
          label: 'Close',
        },
        createButton: {
          label: 'Create',
        },
      },
      addUserPanel: {
        subtitle: 'Add users',
        description:
          "You've successfully created a federated organisation. We'll now need you to add their first user.",
        orgNameLabel: 'Name',
        orgUsersLabel: 'Users',
        closeButton: {
          label: 'Close',
        },
        showAddModalButton: {
          label: 'Add user',
        },
      },
    },
  },
};
